import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html } from "lit";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfSpacer = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_size = "s";
  }
  render() {
    const paddingClass = `dsf-pl-${this.dsf_size} dsf-pt-${this.dsf_size}`;
    return html`<div class="${paddingClass}"></div>`;
  }
};
DsfSpacer.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
__decorateClass([
  prop({ type: String, reflect: true })
], DsfSpacer.prototype, "dsf_size", 2);
DsfSpacer = __decorateClass([
  defineElement("dsf-spacer")
], DsfSpacer);
export {
  DsfSpacer
};
